var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "g",
    {
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip11)" } }, [
        _c("circle", {
          attrs: {
            cx: "22.39",
            cy: "16",
            r: "15.5",
            fill: "white",
            "fill-opacity": "0.01",
            stroke: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M25.8301 10.9901C25.8521 11.0182 25.8755 11.0452 25.9001 11.0709C24.9029 11.2579 23.9615 11.6908 23.1649 12.338C22.7419 12.6816 22.3697 13.0775 22.0556 13.5138C22.2796 13.7498 22.4817 14.0038 22.6603 14.2726C22.893 13.9129 23.1716 13.5812 23.4917 13.2866C24.4266 12.4261 25.6482 11.944 26.9188 11.934C28.1895 11.924 29.4185 12.3869 30.3668 13.2326C31.3152 14.0784 31.9151 15.2466 32.0501 16.5101L32.1001 17.0301L32.0401 17.5401C31.8737 18.7791 31.2606 19.9146 30.3161 20.7335C29.3715 21.5524 28.1604 21.9982 26.9104 21.9871C25.6603 21.9761 24.4573 21.5089 23.5274 20.6735C23.2881 20.4586 23.0712 20.223 22.8784 19.9706C22.7122 20.2671 22.5191 20.5487 22.301 20.8115C22.5642 21.1258 22.8601 21.4144 23.1855 21.672C24.2784 22.5372 25.6362 22.9992 27.0301 22.9801C28.4198 22.9946 29.7727 22.5334 30.8641 21.673C31.9555 20.8126 32.7198 19.6048 33.0301 18.2501C33.3307 18.2227 33.6102 18.0838 33.8138 17.8609C34.0173 17.6379 34.1302 17.347 34.1302 17.0451C34.1302 16.7432 34.0173 16.4522 33.8138 16.2292C33.6102 16.0063 33.3307 15.8675 33.0301 15.8401C32.7417 14.4622 31.9879 13.2256 30.8953 12.338C29.9349 11.5578 28.7642 11.089 27.5389 10.987L29.1501 9.01012L28.3801 8.37012L26.7501 10.3701H26.6201L26.0501 9.63011L25.2601 10.2501L25.8301 10.9901ZM32.8601 17.2201L32.6401 17.0601L32.8601 16.9301C32.8858 16.9029 32.9193 16.8844 32.9561 16.8772C32.9928 16.87 33.0308 16.8743 33.0649 16.8897C33.099 16.9051 33.1275 16.9308 33.1463 16.9631C33.1652 16.9954 33.1735 17.0328 33.1701 17.0701C33.1701 17.2201 33.0601 17.3701 32.8601 17.2201Z",
            fill: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            d: "M24.6498 17.3599H25.86V16.3599H24.5401V17.0035C24.6078 17.1095 24.6461 17.2325 24.6498 17.3599Z",
            fill: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            d: "M29.4101 16.3599H28.0901V17.3599H29.4101V16.3599Z",
            fill: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            d: "M26.8601 20.5601H27.2001V20.5901C27.4543 20.5902 27.706 20.5395 27.9404 20.441C28.1747 20.3425 28.3871 20.1982 28.565 20.0166C28.7429 19.835 28.8827 19.6197 28.9763 19.3833C29.0699 19.147 29.1154 18.8943 29.1101 18.6401H28.1101C28.1127 18.7613 28.0912 18.8818 28.0466 18.9945C28.0021 19.1072 27.9355 19.2099 27.8507 19.2966C27.7659 19.3832 27.6647 19.452 27.553 19.499C27.4413 19.546 27.3213 19.5701 27.2001 19.5701H26.8601C26.7375 19.5688 26.6165 19.5431 26.504 19.4944C26.3916 19.4457 26.29 19.3751 26.2052 19.2866C26.1204 19.1981 26.0542 19.0935 26.0104 18.9791C25.9666 18.8646 25.9461 18.7426 25.9501 18.6201H25.4501L24.9501 18.6801C24.9605 19.1806 25.166 19.6573 25.5228 20.0085C25.8796 20.3597 26.3594 20.5576 26.8601 20.5601Z",
            fill: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            d: "M16.8101 16.7H15.4901V17.7H16.8101V16.7Z",
            fill: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            d: "M19.0401 16.7H20.36V17.7H19.0401V16.7Z",
            fill: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            d: "M18.1401 20.93H17.8001C17.3004 20.9274 16.8216 20.7292 16.4664 20.3777C16.1112 20.0262 15.9079 19.5496 15.9001 19.05L16.9001 18.98C16.8974 19.1021 16.9189 19.2236 16.9632 19.3374C17.0075 19.4513 17.0738 19.5553 17.1583 19.6435C17.2428 19.7317 17.3438 19.8024 17.4557 19.8516C17.5675 19.9007 17.688 19.9274 17.8101 19.93H18.1501C18.2709 19.9304 18.3906 19.9067 18.5022 19.8604C18.6138 19.814 18.7151 19.7459 18.8001 19.66C18.8873 19.5744 18.9556 19.4714 19.0004 19.3577C19.0452 19.244 19.0655 19.1221 19.0601 19H20.0601C20.0668 19.2545 20.0222 19.5078 19.9291 19.7448C19.836 19.9818 19.6963 20.1976 19.5181 20.3795C19.3399 20.5614 19.127 20.7057 18.892 20.8036C18.657 20.9016 18.4047 20.9514 18.1501 20.95L18.1401 20.93Z",
            fill: "#E73C14",
          },
        }),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M16.8179 11.3755C16.8049 11.3607 16.7923 11.3455 16.7801 11.33L16.2101 10.59L16.9901 9.96996L17.5701 10.71L18.0801 11.03L17.7001 10.71L19.3301 8.70996L20.1001 9.34996L18.5183 11.2907C19.7352 11.4002 20.8961 11.872 21.8478 12.6514C22.9416 13.5472 23.6915 14.7941 23.9701 16.1801C24.2883 16.1801 24.5936 16.3066 24.8186 16.5316C25.0436 16.7566 25.1701 17.0619 25.1701 17.3801C25.1701 17.6984 25.0436 18.0036 24.8186 18.2287C24.5936 18.4537 24.2883 18.5801 23.9701 18.5801C23.6618 19.9367 22.8983 21.1468 21.8067 22.0092C20.7151 22.8715 19.3611 23.3342 17.9701 23.3201C16.5762 23.3393 15.2184 22.8773 14.1255 22.012C13.0325 21.1468 12.2713 19.9312 11.9701 18.5701C11.8039 18.5853 11.6365 18.5658 11.4784 18.5126C11.3202 18.4595 11.1749 18.374 11.0517 18.2615C10.9285 18.1491 10.8301 18.0122 10.7628 17.8595C10.6954 17.7069 10.6606 17.542 10.6606 17.3751C10.6606 17.2083 10.6954 17.0433 10.7628 16.8907C10.8301 16.7381 10.9285 16.6012 11.0517 16.4888C11.1749 16.3763 11.3202 16.2908 11.4784 16.2376C11.6365 16.1845 11.8039 16.1649 11.9701 16.1801C12.2487 14.7941 12.9986 13.5472 14.0923 12.6514C14.8852 12.0021 15.8233 11.5662 16.8179 11.3755ZM12.8601 17.7901C13.0131 19.0241 13.6091 20.1604 14.5372 20.9878C15.4653 21.8153 16.6623 22.2774 17.9057 22.2885C19.149 22.2995 20.354 21.8585 21.2966 21.0477C22.2392 20.2368 22.8552 19.1112 23.0301 17.8801L23.0901 17.3601V16.8501C23.0224 15.5325 22.4487 14.2919 21.4886 13.3869C20.5285 12.482 19.2561 11.9826 17.9368 11.9929C16.6174 12.0033 15.3531 12.5225 14.4072 13.4423C13.4614 14.3621 12.9071 15.6116 12.8601 16.9301V17.7901ZM23.6501 17.3901L23.8601 17.5501C23.9301 17.6001 23.9601 17.6001 23.9701 17.6001C23.9972 17.6015 24.0243 17.5973 24.0497 17.5879C24.0751 17.5784 24.0984 17.5639 24.118 17.5452C24.1377 17.5265 24.1533 17.504 24.1639 17.479C24.1746 17.4541 24.1801 17.4273 24.1801 17.4001C24.1788 17.3646 24.1682 17.3301 24.1492 17.3001C24.1302 17.2701 24.1035 17.2456 24.0719 17.2294C24.0404 17.2131 24.005 17.2055 23.9695 17.2074C23.9341 17.2093 23.8997 17.2206 23.8701 17.2401L23.6501 17.3901ZM11.8601 17.1801C11.807 17.1801 11.7562 17.2012 11.7187 17.2387C11.6812 17.2762 11.6601 17.3271 11.6601 17.3801C11.6601 17.5601 11.9301 17.5901 12.0001 17.5101L12.1201 17.3701L12.0001 17.2401C11.9826 17.2205 11.9609 17.205 11.9367 17.1946C11.9125 17.1842 11.8864 17.1793 11.8601 17.1801Z",
            fill: "#E73C14",
          },
        }),
      ]),
      _c("path", {
        attrs: {
          d: "M8.62 35.7799V39.0799H8.94V40.3499H8.57001V39.4599H6.25V40.3499H5.88V39.0799H6.16C6.30375 38.8211 6.42421 38.55 6.51999 38.2699C6.64756 37.7601 6.70477 37.2352 6.69 36.7099V35.7799H8.62ZM7 36.8699C7.01307 37.3766 6.949 37.8824 6.81 38.3699C6.73568 38.6134 6.6351 38.8482 6.51001 39.0699H8.14001V36.1699H7V36.8699Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M11.4701 37.7399H10.0301V39.0699H11.6301V39.4699H9.56006V35.7799H11.5601V36.1799H10.0401V37.3399H11.4701V37.7399Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M12.97 36.1799H11.85V35.7799H14.58V36.1799H13.47V39.4699H12.99L12.97 36.1799Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M17.38 39.35C17.0632 39.4794 16.7218 39.5374 16.38 39.52C16.1328 39.5367 15.8849 39.4998 15.6532 39.4118C15.4216 39.3238 15.2117 39.1868 15.0379 39.0102C14.8641 38.8336 14.7305 38.6214 14.6463 38.3884C14.5621 38.1554 14.5292 37.9069 14.55 37.66C14.534 37.4019 14.5729 37.1434 14.6641 36.9015C14.7554 36.6595 14.8968 36.4397 15.0792 36.2564C15.2615 36.0731 15.4806 35.9305 15.7221 35.838C15.9636 35.7456 16.2219 35.7053 16.48 35.72C16.7814 35.7104 17.0813 35.765 17.36 35.88L17.24 36.27C17.0077 36.1651 16.7548 36.1139 16.5 36.12C16.3009 36.1085 16.1018 36.1407 15.9165 36.2142C15.7311 36.2877 15.5641 36.4008 15.427 36.5455C15.2898 36.6902 15.186 36.8632 15.1226 37.0522C15.0592 37.2412 15.0378 37.4418 15.06 37.64C15.0393 37.8334 15.0611 38.029 15.1236 38.2131C15.1862 38.3973 15.2881 38.5657 15.4222 38.7065C15.5564 38.8473 15.7196 38.9573 15.9006 39.0287C16.0815 39.1001 16.2758 39.1312 16.47 39.12C16.7374 39.1226 17.0026 39.0716 17.25 38.97L17.38 39.35Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.47 35.7799V37.4099H18.62L19.88 35.7799H20.47L19.07 37.4699C19.68 37.5499 19.91 37.9199 20.07 38.4199C20.1818 38.7777 20.3154 39.1284 20.47 39.4699H19.96C19.827 39.188 19.7134 38.8973 19.62 38.5999C19.5774 38.367 19.4535 38.1567 19.2704 38.0065C19.0873 37.8563 18.8568 37.776 18.62 37.7799H18.47V39.4699H18V35.7799H18.47Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M21.4 35.7799V37.3299C21.4 37.9199 21.4 38.3999 21.35 38.8899C21.54 38.5099 21.77 38.1099 22.04 37.6699L23.23 35.7699H23.71V39.4599H23.26V37.8699C23.26 37.2699 23.26 36.8699 23.26 36.3699C23.0609 36.7997 22.8302 37.2141 22.57 37.6099L21.47 39.4699H20.96V35.7799H21.4Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M25.0001 35.78V37.33C25.0001 37.92 25.0001 38.4 25.0001 38.89C25.1901 38.51 25.4201 38.11 25.6801 37.67L26.8801 35.77H27.3601V39.46H26.9101V37.87C26.9101 37.27 26.9101 36.87 26.9101 36.37C26.7106 36.7977 26.4834 37.2119 26.2301 37.61L25.0701 39.45H24.5601V35.76L25.0001 35.78ZM25.6001 35C25.6001 35.17 25.6801 35.34 25.9401 35.34C26.2001 35.34 26.25 35.18 26.2701 35H26.6401C26.6401 35.37 26.3901 35.59 25.9301 35.59C25.8449 35.6029 25.758 35.5973 25.6751 35.5737C25.5923 35.55 25.5156 35.5088 25.4501 35.4528C25.3847 35.3968 25.332 35.3274 25.2958 35.2493C25.2595 35.1711 25.2405 35.0861 25.2401 35H25.6001Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M31.9 39.35C31.5828 39.4781 31.2417 39.5361 30.9 39.52C30.6528 39.5367 30.4048 39.4998 30.1732 39.4118C29.9416 39.3238 29.7317 39.1868 29.5579 39.0102C29.3841 38.8336 29.2505 38.6214 29.1663 38.3884C29.0821 38.1554 29.0493 37.9069 29.07 37.66C29.054 37.4019 29.093 37.1434 29.1842 36.9015C29.2754 36.6595 29.4168 36.4397 29.5992 36.2564C29.7815 36.0731 30.0006 35.9305 30.2421 35.838C30.4835 35.7456 30.7418 35.7053 31 35.72C31.3013 35.7104 31.6013 35.765 31.88 35.88L31.76 36.27C31.5277 36.1651 31.2748 36.1139 31.02 36.12C30.8201 36.107 30.6198 36.1381 30.4333 36.2109C30.2467 36.2837 30.0784 36.3965 29.9401 36.5414C29.8019 36.6864 29.6971 36.8598 29.6332 37.0496C29.5692 37.2394 29.5476 37.4409 29.57 37.64C29.5509 37.8339 29.574 38.0297 29.6378 38.2138C29.7016 38.398 29.8045 38.5662 29.9394 38.7068C30.0743 38.8474 30.2381 38.9571 30.4194 39.0285C30.6008 39.0998 30.7954 39.131 30.99 39.12C31.2574 39.1226 31.5226 39.0716 31.77 38.97L31.9 39.35Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M33.12 38.3099L32.73 39.4699H32.24L33.5 35.7799H34.07L35.33 39.4699H34.82L34.43 38.3099H33.12ZM34.33 37.9299L33.97 36.8699C33.88 36.6299 33.83 36.4099 33.77 36.1999C33.72 36.4199 33.66 36.6399 33.59 36.8699L33.23 37.9299H34.33Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M38.54 35.7799V39.0799H38.86V40.3499H38.47V39.4599H36.14V40.3499H35.77V39.0799H36.05C36.198 38.8232 36.3187 38.5517 36.41 38.2699C36.5426 37.761 36.5999 37.2354 36.58 36.7099V35.7799H38.54ZM36.92 36.8699C36.9331 37.3766 36.869 37.8824 36.73 38.3699C36.6602 38.615 36.5594 38.8503 36.43 39.0699H38.06V36.1699H36.92V36.8699Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M1.2099 46.45L2.28992 47.94H1.71991L0.649902 46.45L1.71991 44.96H2.28992L1.2099 46.45ZM2.53992 46.45L3.6199 47.94H3.0499L1.97992 46.45L3.0499 44.96H3.6199L2.53992 46.45Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M4.32999 47.6299C4.70846 47.8645 5.14473 47.9891 5.59 47.9899C6.31 47.9899 6.73001 47.6099 6.73001 47.0599C6.73001 46.5099 6.44001 46.2599 5.73001 45.9699C4.84001 45.6599 4.29001 45.1999 4.29001 44.4299C4.30077 44.2131 4.35607 44.0008 4.45251 43.8063C4.54896 43.6118 4.68444 43.4393 4.85052 43.2995C5.01661 43.1597 5.20972 43.0556 5.41782 42.9937C5.62591 42.9319 5.84451 42.9136 6.06 42.9399C6.47662 42.9246 6.8901 43.0176 7.26001 43.2099L7.07001 43.7899C6.76291 43.6229 6.41957 43.5336 6.07001 43.5299C5.33001 43.5299 5.07001 43.9699 5.07001 44.3399C5.07001 44.7099 5.41 45.1099 6.16 45.3999C7.08 45.7499 7.54999 46.1999 7.54999 46.9999C7.54999 47.7999 6.93001 48.5699 5.64001 48.5699C5.15526 48.5771 4.67672 48.46 4.25 48.2299L4.32999 47.6299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.02 46.0899C13.02 45.3299 12.93 44.4199 12.93 43.7399C12.74 44.3799 12.52 45.0599 12.24 45.8099L11.24 48.4599H10.7L9.82004 45.8599C9.56004 45.0899 9.34003 44.3799 9.19003 43.7399C9.19003 44.4199 9.14003 45.3299 9.09003 46.1499L8.94003 48.4899H8.27002L8.65002 43.0299H9.55002L10.48 45.6699C10.71 46.3499 10.89 46.9499 11.03 47.5099C11.16 46.9599 11.36 46.3599 11.6 45.6699L12.6 43.0299H13.5L13.84 48.4899H13.15L13.02 46.0899Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M15.6299 43.0299V48.4899H14.9299V43.0299H15.6299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.86 43.0299H17.57V47.8699H19.9V48.4599H16.9L16.86 43.0299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.47 45.9299H21.35V47.9299H23.72V48.5199H20.64V43.0599H23.64V43.6499H21.4V45.3799H23.47V45.9299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M26.39 43.0299H29.33V43.6199H27.09V45.4399H29.16V46.0199H27.09V48.4899H26.39V43.0299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M31.03 43.0299V48.4899H30.33V43.0299H31.03Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M32.17 47.6299C32.5485 47.8645 32.9847 47.9891 33.43 47.9899C34.15 47.9899 34.57 47.6099 34.57 47.0599C34.57 46.5099 34.28 46.2599 33.57 45.9699C32.86 45.6799 32.13 45.1999 32.13 44.4299C32.1407 44.2131 32.1961 44.0008 32.2925 43.8063C32.389 43.6118 32.5244 43.4393 32.6905 43.2995C32.8566 43.1597 33.0497 43.0556 33.2578 42.9937C33.4659 42.9319 33.6845 42.9136 33.9 42.9399C34.3196 42.926 34.736 43.0189 35.11 43.2099L34.91 43.7899C34.603 43.6225 34.2596 43.5332 33.91 43.5299C33.16 43.5299 32.91 43.9699 32.91 44.3399C32.91 44.7099 33.24 45.1099 33.99 45.3999C34.92 45.7499 35.39 46.1999 35.39 46.9999C35.39 47.7999 34.76 48.5699 33.47 48.5699C32.9854 48.5758 32.5072 48.4588 32.08 48.2299L32.17 47.6299Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M36.96 43.0299V45.3199H39.6V43.0299H40.32V48.4899H39.6V45.9299H36.96V48.4899H36.26V43.0299H36.96Z",
          fill: "black",
        },
      }),
      _c("path", {
        attrs: {
          d: "M41.11 44.96H41.68L42.76 46.45L41.68 47.94H41.12L42.19 46.45L41.11 44.96ZM42.43 44.96H43.01L44.08 46.45L43.01 47.94H42.47L43.54 46.45L42.43 44.96Z",
          fill: "black",
        },
      }),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip11" } }, [
          _c("rect", {
            attrs: {
              width: "32",
              height: "32",
              fill: "white",
              transform: "translate(6.39001)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }